import type React from "react";
import type { Post } from "@/types/channel/post";
import { PostItem } from "../PostItem/PostItem";

interface PostListProps {
	posts: Post[];
}

export const PostList: React.FC<PostListProps> = ({ posts }) => {
	return (
		<div className="space-y-6">
			{posts.length === 0 ? (
				<p className="text-center text-gray-500 py-8">
					まだ投稿がありません。最初の投稿を作成しましょう！
				</p>
			) : (
				posts.map((post) => <PostItem key={post.id} post={post} />)
			)}
		</div>
	);
};
